import React from 'react'
import { useState } from 'react'
import { pdf } from '@react-pdf/renderer'
import type { DocumentProps } from '@react-pdf/renderer'
import { registerFonts } from './theme'
import { ReadershipsReport } from './documents/ReadershipsReport'
import type { ReadershipsReportData } from './documents/ReadershipsReport'

export type { ReadershipsReportData } from './documents/ReadershipsReport'

function toFilename(s: string): string {
  return s
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/-+$/, '')
    .slice(0, 80)
}

export function useReadershipPdf() {
  const [isGenerating, setIsGenerating] = useState(false)

  async function downloadPdf(data: ReadershipsReportData, filename: string): Promise<void> {
    setIsGenerating(true)
    try {
      registerFonts()
      const element = React.createElement(ReadershipsReport, {
        data,
        generatedAt: new Date(),
      })
      const blob = await pdf(element as React.ReactElement<DocumentProps>).toBlob()
      const url = URL.createObjectURL(blob)
      const anchor = document.createElement('a')
      anchor.href = url
      anchor.download = `${toFilename(filename) || 'readership-report'}.pdf`
      anchor.click()
      URL.revokeObjectURL(url)
    } finally {
      setIsGenerating(false)
    }
  }

  return { downloadPdf, isGenerating }
}
